import { render, staticRenderFns } from "./TestLanding.vue?vue&type=template&id=4554e302&scoped=true&"
import script from "./TestLanding.vue?vue&type=script&lang=js&"
export * from "./TestLanding.vue?vue&type=script&lang=js&"
import style0 from "./TestLanding.vue?vue&type=style&index=0&id=4554e302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554e302",
  null
  
)

component.options.__file = "TestLanding.vue"
export default component.exports